import React, {Component} from 'react';
import objeler from '../objeler';
import ComboBox from "./ComboBox";
import 'react-dropdown/style.css'
import './modal.css'
import {Col, Container, Row} from 'react-bootstrap';
import ReactTooltip from "react-tooltip";
import Datasource from '../Datasource/Datasource'
import DialogStyles from '../ModalDialog/DialogStyles'
import {withStyles} from '@material-ui/core/styles';
import axios from 'axios';
import {withAlert} from '../../react-alert-master/src'
import Loader from '../../react-fullpage-custom-loader/dist/index'
import "rc-tree/assets/index.less";
import "./Tree/styles.css";
import * as XLSX from "../../sheetjs-master/dist/xlsx";
import ModalDialogConnect from '../Datasource/ModalDialogConnect';
import axiosInstance from '../token/axiosInstance'
const modalConnect = React.createRef();
const toolTipClass = 'text-md px-2 py-2 leading-none mt-3 '
const dsInit = [
    {
        id: 0,
        title: 'MAIN',
        query: "",
        keys: "",
        rows: []
    }];
const LoaderTextInit = 'Datasource';
const dataProviderItems = require('../../items/dataProviders.json');

class DataProperties extends Component {
    options = [
        '6', '7', '8', '9'
    ];
    defaultOption = this.options[0];

    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.state = {
            dsTab: objeler.ModalDocParameters.DataSource,
            activeFontFamily: "Open Sans",
            activeBold: "false",
            oleDbFile: objeler.ModalDocParameters.OleDbFile,
            stateDatasource: null,
            ShowLoaderDS: false,
            LoaderText: LoaderTextInit,
            modalConnectIsOpen: false,
            buildOracle: objeler.buildOracle
        };
        this.onChangeDataFile = this.onChangeDataFile.bind(this)
        objeler['ModalDocValues'] = {
            ...objeler.ModalDocParameters,
            DataSource: JSON.parse(JSON.stringify(objeler.ModalDocParameters.DataSource))
        };
        this.ensureOutlineDefaults(objeler.ModalDocValues.DataSource);
        this.buildConnection();
    };

    setStateDataSource() {
        this.ensureOutlineDefaults(this.state.dsTab);
        this.setState({
            stateDatasource: <Datasource data={this.state.dsTab} provider={objeler.ModalDocValues.DataProvider}/>,
            ShowLoaderDS: false,
            LoaderText: LoaderTextInit
        });
    }

    ensureOutlineDefaults(dataSources) {
        if (!dataSources || dataSources.length === 0) return;

        const currentOutlineDs = objeler.ModalDocValues.OutlineDataSource;

        const targetDs = currentOutlineDs
            ? dataSources.find(ds => ds && (ds.title === currentOutlineDs || ds.Name === currentOutlineDs))
            : dataSources[0];

        if (!targetDs) return;

        if (!objeler.ModalDocValues.OutlineDataSource) {
            objeler.ModalDocValues.OutlineDataSource = targetDs.title || targetDs.Name || "";
        }

        if (!objeler.ModalDocValues.OutlineItem) {
            let candidate = "";

            if (targetDs.rows && targetDs.rows.length > 0) {
                candidate = targetDs.rows[0].Name || targetDs.rows[0].value || "";
            }

            if (!candidate && targetDs.keys) {
                candidate = targetDs.keys.split(',')[0];
            }

            if (!candidate && targetDs.query) {
                const selectParts = targetDs.query
                    .replace(/select/i, "")
                    .split(/from/i);
                if (selectParts.length > 0) {
                    const firstColumn = selectParts[0]
                        .split(',')
                        .map(s => s.trim())
                        .filter(Boolean)[0];
                    if (firstColumn) {
                        candidate = firstColumn;
                    }
                }
            }

            objeler.ModalDocValues.OutlineItem = candidate;
        }
    }

    componentDidMount() {
        this.ensureOutlineDefaults(objeler.ModalDocValues.DataSource);
        this.setStateDataSource();
        this.buildConnection();
    }

    componentWillMount() {
        this.ensureOutlineDefaults(objeler.ModalDocValues.DataSource);
        this.setStateDataSource();
        this.buildConnection();
    }

    get_header_row(sheet) {
        let headers = [];
        let range = XLSX.utils.decode_range(sheet['!ref']);
        let C, R = range.s.r;
        for (C = range.s.c; C <= range.e.c; ++C) {
            let cell = sheet[XLSX.utils.encode_cell({c: C, r: R})]
            let hdr = "";
            if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
            headers.push(hdr);
        }
        return headers;
    }

    processExcel(data, blb) {
        let blob = window.URL.createObjectURL(blb);
        this.setState({stateDatasource: null, ShowLoaderDS: true});
        this.checkdb({blob: blob, name: blb.name}).then(response => {
            if (!response) {
                console.log('OLD FILE', objeler.ModalDocValues.OleDbFile)
                console.log('OLD FILE', objeler.ModalDocValues.DataSource)
                this.setState({
                    dsTab: [...objeler.ModalDocValues.DataSource],
                    oleDbFile: objeler.ModalDocValues.OleDbFile,
                    ShowLoaderDS: false
                });
                this.setStateDataSource();
                return;
            }
            const workbook = XLSX.read(data, {type: 'binary', sheetRows: 2});
            const firstSheet = workbook.SheetNames[0];
            let tab = [];
            for (let i in workbook.SheetNames) {
                let rw = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[workbook.SheetNames[i]]);
                if (rw[0] == undefined) continue;
                var rwKey = Object.keys(rw[0]);
                var rows = rwKey.map(key => ({Name: key, DataType: 'String'}));
                console.log(`📋 Sheet "${workbook.SheetNames[i]}" - Fields:`, rows);
                var tt = {
                    id: tab.length,
                    title: workbook.SheetNames[i],
                    query: "select " + rwKey.join() + " from [" + workbook.SheetNames[i] + "$]",
                    keys: rwKey.join(','),
                    rows: rows
                }
                tab.push(tt);
            }
            objeler.ModalDocValues.DataSource = tab;
            this.ensureOutlineDefaults(tab);
            this.setState({dsTab: tab});
            objeler["oleDbFile"] = blb;
            objeler.ModalDocValues.OleDbFile = blb.name;
            objeler.ModalDocValues.OleDbFileBlob = window.URL.createObjectURL(blb);
            this.setStateDataSource();
        });
    }

    async checkdb(e) {
        let success = true;
        const {alert} = this.props;
        let blob = await fetch(e.blob).then(r => r.blob());
        const data = new FormData();
        data.append('file', blob);
        data.append('filename', e.name);
        console.log('checkdb', window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/checkdb')
        await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/checkdb', data
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`},
                responseType: 'arraybuffer'
            }
        ).then((response) => {
            switch (response.status) {
                case 210:
                    console.log('ERR', response.status);
                    alert.show(e.name + ' datasource file is not in table structure.', true, {
                        title: "Datasource Error",
                        closeCopy: "OK"
                    });
                    var enc = new TextDecoder("utf-8");
                    success = false;
                    break;
            }
        }).catch(function (error) {
            success = true;
            console.log('err', error);
            alert.show('Unable to connect to server.Try again later.', true, {
                title: "Nerwork Error",
                closeCopy: "OK"
            });
            if (error.response) {
                switch (error.response.status) {
                    case 450:
                        alert.show('Wrong password of certificate file', true, {
                            title: "Nerwork Error",
                            closeCopy: "OK"
                        });
                        break;
                }
            }
        })
        return success;
    }

    async checkdbOracle_old(e) {
        let success = false;
        const {alert} = this.props;
        await axiosInstance.get(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/checkdboracle/' + e
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`},
                responseType: 'text'
            }
        ).then((response) => {
            console.log('response', response);
            switch (response.status) {
                case 200:
                    if (response.data == 0) {
                        alert.show("Connection Succeded", true, {
                            title: "Oracle Connection",
                            closeCopy: "OK"
                        });
                        var enc = new TextDecoder("utf-8");
                        success = true;
                        break;
                    } else {
                        alert.show('Unable to connect to server.Try again later.', true, {
                            title: "Nerwork Error",
                            closeCopy: "OK"
                        });
                        success = false;
                        break;
                    }
                    break;
                case 210:
                    console.log('ERR2', response.message);
                    alert.show(response.data, true, {
                        title: "Datasource Error",
                        closeCopy: "OK"
                    });
                    var enc = new TextDecoder("utf-8");
                    success = false;
                    break;
            }
        }).catch(function (error) {
            success = false;
            console.log('err', error);
            alert.show('Unable to connect to server.Try again later.', true, {
                title: "Nerwork Error",
                closeCopy: "OK"
            });
            if (error.response) {
                switch (error.response.status) {
                    case 450:
                        alert.show('Wrong password of certificate file', true, {
                            title: "Nerwork Error",
                            closeCopy: "OK"
                        });
                        break;
                }
            }
        })
        return success;
    }

    async checkdbOracle(e, p) {
        console.log('poriver', p)
        let success = false;
        const {alert} = this.props;
        var ticks = new Date().getTime();
        const data = new FormData();
        data.append('constr', e);
        data.append('ticks', ticks);
        data.append('provider', p);
        console.log(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/checkdboracle')
        await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/checkdboracle', data
            , {
                headers: {
                    // Authorization: `Bearer ${objeler.User.Token.AccessToken}`
                }
            }
        ).then((response) => {
            console.log('response', response);
            if (response.data == "" || response.data == 'NoResponse') {
                success = false;
                alert.show('Unable to connect to server.Try again later.', true, {
                    title: "Nerwork Error",
                    closeCopy: "OK"
                });
            } else {
                if (response.data.output != "0") {
                    alert.show(response.data.output, true, {
                        title: (objeler.buildOracle.dbtype == 'Oracle' ? 'Oracle' : 'PostgreSQL') + ' Error',
                        closeCopy: "OK"
                    });
                    success = false;
                } else {
                    if (response.data.value == ticks) {
                        alert.show("Connection Succeded", true, {
                            title: "Oracle Connection",
                            closeCopy: "OK"
                        });
                    } else {
                        alert.show('Unable to connect to server2.Try again later.', true, {
                            title: "Nerwork Error",
                            closeCopy: "OK"
                        });
                    }
                    success = true;
                }
            }
        }).catch(function (error) {
            success = false;
            console.log('err', error);
            alert.show('Unable to connect to server.Try again later.', true, {
                title: "Nerwork Error",
                closeCopy: "OK"
            });
            if (error.response) {
                switch (error.response.status) {
                    case 450:
                        alert.show('Wrong password of certificate file', true, {
                            title: "Nerwork Error",
                            closeCopy: "OK"
                        });
                        break;
                }
            }
        })
        return success;
    }

    async onChangeDataFile(e) {
        var tab = [];
        var success;
        const {alert} = this.props;
        var targetfiles = e.target.files[0];
        let blb = window.URL.createObjectURL(targetfiles);
        this.setState({ShowLoaderDS: true, LoaderText: targetfiles.name});
        let blob = await fetch(blb).then(r => r.blob());
        const data = new FormData();
        data.append('file', blob);
        data.append('filename', e.name);
        await axiosInstance.post(window.GET_API_URL(process.env.REACT_APP_SERVICE) + '/api/wdc/checkdb', data
            , {
                // headers: {Authorization: `Bearer ${objeler.User.Token.AccessToken}`}
            }
        ).then((response) => {
            switch (response.status) {
                case 200:
                    tab = response.data;
                    objeler.ModalDocValues.DataSource = tab;
                    this.ensureOutlineDefaults(tab);
                    this.setState({dsTab: tab});
                    objeler["oleDbFile"] = blb;
                    objeler.ModalDocValues.OleDbFile = targetfiles.name;
                    objeler.ModalDocValues.OleDbFileBlob = blb;
                    this.setState({oleDbFile: targetfiles.name});
                    this.setState({
                        stateDatasource: <Datasource data={tab} provider={objeler.ModalDocValues.DataProvider}/>,
                        ShowLoaderDS: false,
                        LoaderText: LoaderTextInit
                    });
                    break;
                case 210:
                    console.log('HATA', response);
                    alert.show(targetfiles.name + ' datasource file is not in table structure.', true, {
                        title: "Datasource Error",
                        closeCopy: "OK"
                    });
                    var enc = new TextDecoder("utf-8");
                    console.log('OLD FILE', objeler.ModalDocValues.OleDbFile)
                    console.log('OLD FILE', objeler.ModalDocValues.DataSource)
                    this.setState({
                        dsTab: [...objeler.ModalDocValues.DataSource],
                        oleDbFile: objeler.ModalDocValues.OleDbFile,
                        ShowLoaderDS: false,
                        LoaderText: LoaderTextInit
                    });
                    success = false;
                    tab = [...objeler.ModalDocValues.DataSource];
                    break;
            }
        }).catch((error) => {
            console.log('ERR', error);
            this.setState({ShowLoaderDS: false, LoaderText: LoaderTextInit});
            success = true;
            alert.show('Unable to connect to server.Try again later.', true, {
                title: "Nerwork Error",
                closeCopy: "OK"
            });
            if (error.response) {
                switch (error.response.status) {
                    case 450:
                        alert.show('Wrong password of certificate file', true, {
                            title: "Nerwork Error",
                            closeCopy: "OK"
                        });
                        break;
                }
            }
        })
        return;
    }

    onChangeDataFile2(e) {
        var targetfiles = e.target.files[0];
        this.setState({oleDbFile: targetfiles.name})
        let fileName = e.target.files[0].name;
        if (typeof (FileReader) !== 'undefined') {
            const reader = new FileReader();
            if (reader.readAsBinaryString) {
                reader.onload = (e) => {
                    this.processExcel(reader.result, targetfiles);
                };
                reader.readAsBinaryString(targetfiles);
            }
        } else {
            console.log("This browser does not support HTML5.");
        }
        this.setState({oleDbFile: targetfiles.name}, () => {
        });
        return;
    }

    clearExcel(e) {
        const {alert} = objeler.Editor.props;
        alert.success("Are you sure you want to remove it?", true
            , {
                title: "Warning",
                closeCopy: "Cancel",
                actions: [
                    {
                        copy: "OK",
                        onClick: () => {
                            this.clearExcelOK()
                        },
                    }
                ]
            }
        );
    }

    clearExcelOK(e) {
        objeler.ModalDocValues.OleDbFile = "";
        objeler.ModalDocValues.OleDbFileBlob = null;
        objeler.ModalDocValues.DataSource = [];
        this.setState({
            dsTab: [...objeler.ModalDocValues.DataSource],
            oleDbFile: objeler.ModalDocValues.OleDbFile,
            ShowLoaderDS: false,
            LoaderText: LoaderTextInit
        });
        var dsTab = [];
        objeler.dsClass.setDataSource(dsTab);
        this.setState({
            stateDatasource: <Datasource data={dsTab} provider={objeler.ModalDocValues.DataProvider}
                                         update/>
        });
    }

    async downloadExcel(e) {
        console.log('this.state.oleDbFile', objeler.ModalDocValues.OleDbFileBlob)
        const link = document.createElement("a");
        link.download = objeler.ModalDocValues.OleDbFile;
        link.href = objeler.ModalDocValues.OleDbFileBlob;
        link.click();
    }

    onChangeProvider(e) {
        this.setState({stateDatasource: null, ShowLoaderDS: false, LoaderText: LoaderTextInit});
        objeler.ModalDocValues.OleDbFile = null;
        objeler.ModalDocValues.ConnectionString = "";
        this.setState({oleDbFile: objeler.ModalDocValues.OleDbFile})
        var dsTab = [...dsInit];
        if (e.target.value == "OleDb") {
            dsTab = [];
        } else
            objeler.ModalDocValues.OleDbFile = null;
        this.setState({value: e.target.value});
        this.setState({dsTab: dsTab})
        objeler.ModalDocValues.DataProvider = e.target.value;
        objeler.dsClass.setDataSource(dsTab);
        this.setState({
            stateDatasource: <Datasource data={dsTab} provider={objeler.ModalDocValues.DataProvider}
                                         update/>
        });
    }

    updateInputValue(e) {
        objeler.ModalDocValues.ConnectionString = e.target.value;
    }

    parseValue(e, t) {
        let r = "";
        for (let i = 0; i < t.length; i++) {
            let tt = t[i].replaceAll(' ', '').match(new RegExp(e + '=(.*)$', 'gm'));
            if (tt != null) {
                r = t[i].replaceAll(' ', '').split("=")[1];
                break;
            }
        }
        return r;
    }

    buildConnection(e) {
        console.log('xzccffd', objeler.ModalDocValues.DataProvider)
        switch (objeler.ModalDocValues.DataProvider) {
            case "Oracle":
                var c = objeler.ModalDocValues.ConnectionString;
                var t = c.split('(').join(',').split(')').join(',').split(';').join(',').split(',')
                console.log('OOOOOOOOOOO')
                let sid = this.parseValue('SID', t);
                let service = this.parseValue('SERVICE_NAME', t);
                objeler.buildOracle =
                    {
                        server: this.parseValue('HOST', t),
                        port: this.parseValue('PORT', t),
                        sid: service == "" ? sid : service,
                        user: this.parseValue('UserId', t),
                        password: this.parseValue('Password', t),
                        type: service == "" ? 0 : 1,
                        dbtype: "Oracle"
                    };
                break;
                console.log('zzzzzzzzz', objeler.buildOracle)
            case "PostgreSQL":
                var c = objeler.ModalDocValues.ConnectionString;
                var t = c.split('(').join(',').split(')').join(',').split(';').join(',').split(',')
                console.log('pppppppppp')
                objeler.buildOracle =
                    {
                        server: this.parseValue('Server', t),
                        port: this.parseValue('Port', t),
                        database: this.parseValue('Database', t),
                        user: this.parseValue('UserID', t),
                        password: this.parseValue('Password', t),
                        dbtype: "PostgreSQL"
                    };
                console.log('zzzzzzzzz', objeler.buildOracle, t)
                break;
            default:
                objeler.buildOracle =
                    {
                        server: "",
                        port: "",
                        database: "",
                        user: "",
                        password: "",
                        dbtype: "",
                    };
                break;
        }
        this.setState({buildOracle: objeler.buildOracle})
    }

    openConnection(e) {
        this.buildConnection(e)
        this.setState({modalConnectIsOpen: true})
    }

    closeModal() {
        this.setState({modalConnectIsOpen: false});
        var conn = "";
        if (objeler.buildOracle.dbtype == "Oracle") {
            if (objeler.buildOracle.type == 0)
                conn = "Data Source=(DESCRIPTION=(ADDRESS=(PROTOCOL=TCP)(HOST = " + objeler.buildOracle.server + ")(PORT = " + objeler.buildOracle.port + "))(CONNECT_DATA=(SID = " + objeler.buildOracle.sid + ")));User Id=" + objeler.buildOracle.user + ";Password=" + objeler.buildOracle.password + ";Max Pool Size = 128;Incr Pool Size = 128;Decr Pool Size = 128;Min Pool Size = 128";
            else
                conn = "Data Source=(DESCRIPTION=(ADDRESS=(PROTOCOL=TCP)(HOST = " + objeler.buildOracle.server + ")(PORT = " + objeler.buildOracle.port + "))(CONNECT_DATA=(SERVER=dedicated) (SERVICE_NAME = " + objeler.buildOracle.sid + ")));User Id=" + objeler.buildOracle.user + ";Password=" + objeler.buildOracle.password + ";Max Pool Size = 128;Incr Pool Size = 128;Decr Pool Size = 128;Min Pool Size = 128";
        }
        if (objeler.buildOracle.dbtype == "PostgreSQL") {
            conn = "User ID=" + objeler.buildOracle.user + ";Password=" + objeler.buildOracle.password + ";Server=" + objeler.buildOracle.server + ";Port=" + objeler.buildOracle.port + ";Database=" + objeler.buildOracle.database + ";Integrated Security=true;Pooling=true;"
        }
        objeler.ModalDocValues.ConnectionString = conn;
        this.setState({buildOracle: objeler.buildOracle})
        objeler.buildOracle = {};
    }

    render() {
        if (objeler.dsClass != undefined)
            objeler.dsClass.setDataSource(this.state.dsTab);
        const textStyle = {
            display: "block",
            width: "100%",
            height: "24px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const divStyle = {
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
            , height: '360px'
            , width: '740px'
        };
        const dataSourceStyle = {
            display: "block",
            width: "100px",
            height: "25px",
            zIndex: "0"
        };
        const comboStyle = {
            display: "block",
            width: "150px",
            height: "25px",
            zIndex: "0",
            vAlign: "middle",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const browseTextStyle = {
            display: "block",
            width: "70px",
            height: "25px",
            zIndex: "0",
            marginTop: "11px",
            fontSize: "12px",
            justifyContent: 'center',
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const passwordStyle = {
            display: "block",
            width: "100%",
            height: "25px",
            zIndex: "0"
        };
        const fileTextStyle = {
            display: "block",
            width: "140px",
            height: "25px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        const {classes} = this.props;
        return (
            <div style={divStyle}>
                <ModalDialogConnect
                    ref={modalConnect}
                    isOpen={this.state.modalConnectIsOpen}
                    closeModal={e => {
                        this.closeModal()
                    }}
                    checkdbOracle={e => this.checkdbOracle(e, objeler.ModalDocValues.DataProvider)}
                >
                </ModalDialogConnect>
                {this.state.ShowLoaderDS && <Loader
                    wrapperBackgroundColor={'white'}
                    fullScreen={false}
                    color={'rgba(75, 85, 99 )'}
                    textStyles={{
                        color: 'black',
                        fontSize: '22px',
                        fontWeight: '500',
                        textShadow: '3px 3px 6px rgb(0 0 0/26%),0 0 5px rgb(15 3 86/22%)'
                    }}
                    fadeIn={true}
                    width={'93%'}
                    height={'64%'}
                    topLocation={'120px'}
                    sentences={[this.state.LoaderText + ' checking...', 'Please Wait...']}
                />
                }
                <Container>
                    <Row style={{height: '45px'}}>
                        <Col style={{flexGrow: '3'}} className="ColVAlign"><span style={{whiteSpace: 'nowrap'}}>Data Provider :</span></Col>
                        <Col style={{flexGrow: '4'}} className="ColVAlign">
                            <ComboBox onChange={(e) => {
                                this.onChangeProvider(e)
                            }
                            }
                                      comboStyle={comboStyle}
                                      comboValue={objeler.ModalDocValues.DataProvider}
                                      items={dataProviderItems}
                            />
                        </Col>
                        {
                            (() => {
                                switch (objeler.ModalDocValues.DataProvider) {
                                    case 'PostgreSQL':
                                        return (
                                            <React.Fragment>
                                                <Col style={{flexGrow: '1', width: '56px'}} className="ColVAlign">
                                                    <span style={{whiteSpace: 'nowrap'}}>Server :</span>
                                                </Col>
                                                <Col style={{flexGrow: '1'}} className="ColVAlign">
                                                    <input className="form-control" type="text" readOnly="true"
                                                           style={{width: '110px'}}
                                                           className="disableInput"
                                                           value={this.state.buildOracle.server + " : " + this.state.buildOracle.port}
                                                    />
                                                </Col>
                                                <Col style={{flexGrow: '2', width: '30px'}} className="ColVAlign">
                                                    <span style={{whiteSpace: 'nowrap'}}>Database :</span>
                                                </Col>
                                                <Col style={{flexGrow: '1'}} className="ColVAlign">
                                                    <input className="form-control" type="text" readOnly="true"
                                                           style={{width: '110px'}}
                                                           className="disableInput"
                                                           value={this.state.buildOracle.database}
                                                    />
                                                </Col>
                                                <Col style={{flexGrow: '', float: 'left', paddingLeft: '0'}}
                                                     className="ColVAlign">
                                                    <i className="far fa-database text-gray-600 "
                                                       style={{fontSize: '1.7em', cursor: 'pointer', marginTop: '0px'}}
                                                       onClick={e => {
                                                           this.openConnection(e)
                                                       }}
                                                       data-tip data-for="databaseTip"
                                                    />
                                                </Col>
                                                <ReactTooltip id="databaseTip" place="bottom" effect="solid"
                                                              className={toolTipClass}
                                                >
                                                    Database
                                                </ReactTooltip>
                                            </React.Fragment>
                                        )
                                    case 'Oracle':
                                        return (
                                            <React.Fragment>
                                                <Col style={{flexGrow: '1', width: '56px'}} className="ColVAlign">
                                                    <span style={{whiteSpace: 'nowrap'}}>Server :</span>
                                                </Col>
                                                <Col style={{flexGrow: '1'}} className="ColVAlign">
                                                    <input className="form-control" type="text" readOnly="true"
                                                           style={{width: '110px'}}
                                                           className="disableInput"
                                                           value={this.state.buildOracle.server + " : " + this.state.buildOracle.port}
                                                    />
                                                </Col>
                                                <Col style={{flexGrow: '1', width: '30px'}} className="ColVAlign">
                                                    <span
                                                        style={{whiteSpace: 'nowrap'}}>{this.state.buildOracle.type == 1 ? "Service" : "SID"} :</span>
                                                </Col>
                                                <Col style={{flexGrow: '1'}} className="ColVAlign">
                                                    <input className="form-control" type="text" readOnly="true"
                                                           style={{width: '110px'}}
                                                           className="disableInput"
                                                           value={this.state.buildOracle.sid}
                                                    />
                                                </Col>
                                                <Col style={{flexGrow: '', float: 'left', paddingLeft: '0'}}
                                                     className="ColVAlign">
                                                    <i className="far fa-database text-gray-600 "
                                                       style={{fontSize: '1.7em', cursor: 'pointer', marginTop: '0px'}}
                                                       onClick={e => {
                                                           this.openConnection(e)
                                                       }}
                                                       data-tip data-for="databaseTip"
                                                    />
                                                </Col>
                                                <ReactTooltip id="databaseTip" place="bottom" effect="solid"
                                                              className={toolTipClass}
                                                >
                                                    Database
                                                </ReactTooltip>
                                            </React.Fragment>
                                        )
                                    default:
                                        return (
                                            <React.Fragment>
                                                <Col style={{flexGrow: '1'}} className="ColVAlign"><span
                                                    style={{whiteSpace: 'nowrap'}}>File :</span></Col>
                                                <Col style={{flexGrow: '10'}} className="ColVAlign">
                                                    <input id="oleDbFile" className="form-control" type="text"
                                                           readOnly="true" style={fileTextStyle}
                                                           value={this.state.oleDbFile}
                                                    />
                                                    <form onSubmit={this.onFormSubmit}>
                                                        <label htmlFor="file-upload-cert"
                                                        >
                                                            &nbsp;&nbsp;
                                                            <i className="far fa-file-upload text-gray-600 " style={{
                                                                fontSize: '1.7em',
                                                                cursor: 'pointer',
                                                                paddingTop: '8px'
                                                            }}
                                                               data-tip data-for="uploadTip"
                                                            />
                                                            &nbsp;&nbsp;
                                                            <ReactTooltip id="uploadTip" place="bottom" effect="solid"
                                                                          className={toolTipClass}
                                                            >
                                                                Upload
                                                            </ReactTooltip>
                                                        </label>
                                                        <input id="file-upload-cert" type="file"
                                                               onChange={this.onChangeDataFile}
                                                               style={{display: "none"}}
                                                               accept=".csv, .xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                        />
                                                    </form>
                                                    {objeler.ModalDocValues.OleDbFile &&
                                                        <React.Fragment>
                                                            <i className="far fa-file-download text-gray-600 " style={{
                                                                fontSize: '1.7em',
                                                                cursor: 'pointer',
                                                                paddingTop: '0px'
                                                            }}
                                                               onClick={e => {
                                                                   this.downloadExcel(e)
                                                               }}
                                                               data-tip data-for="downloadTip"
                                                            />
                                                            <ReactTooltip id="downloadTip" place="bottom" effect="solid"
                                                                          className={toolTipClass}
                                                            >
                                                                Download
                                                            </ReactTooltip>
                                                            &nbsp;&nbsp;
                                                            <i className="far fa-file-times text-gray-600 " style={{
                                                                fontSize: '1.7em',
                                                                cursor: 'pointer',
                                                                paddingTop: '0px'
                                                            }}
                                                               onClick={e => {
                                                                   this.clearExcel(e)
                                                               }}
                                                               data-tip data-for="removeTip"
                                                            />
                                                            <ReactTooltip id="removeTip" place="bottom" effect="solid"
                                                                          className={toolTipClass}
                                                            >
                                                                Remove
                                                            </ReactTooltip>
                                                        </React.Fragment>
                                                    }
                                                </Col>
                                            </React.Fragment>
                                        )
                                }
                            }).call(this)}
                    </Row>
                    <Row>
                        <Col>
                            {this.state.stateDatasource}
                            {
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withAlert()(withStyles(DialogStyles)(DataProperties));